/**
 * This is copied from the apollo-client-persist examples:
 * https://github.com/apollographql/apollo-cache-persist/tree/master/examples/react-native/src/utils/persistence
 */
import { type DocumentNode, visit } from 'graphql';
import { type NotWorthIt } from '@/types/utils';

const extractPersistDirectivePaths = (
	originalQuery: DocumentNode,
	directive = 'persist'
) => {
	const paths: NotWorthIt[] = [];
	const fragmentPaths: Record<string, NotWorthIt[]> = {};
	const fragmentPersistPaths: Record<string, NotWorthIt[]> = {};

	const query = visit(originalQuery, {
		FragmentSpread: (
			{ name: { value: name } },
			_key,
			_parent,
			_path,
			ancestors
		) => {
			const root: NotWorthIt = ancestors.find(
				({ kind }: NotWorthIt) =>
					kind === 'OperationDefinition' ||
					kind === 'FragmentDefinition'
			);

			const rootKey =
				root.kind === 'FragmentDefinition' ? root.name.value : '$ROOT';

			const fieldPath = ancestors
				.filter(({ kind }: NotWorthIt) => kind === 'Field')
				.map(({ name: { value: name } }: NotWorthIt) => name);

			fragmentPaths[name] = [rootKey].concat(fieldPath);
		},
		Directive: (
			{ name: { value: name } },
			_key,
			_parent,
			_path,
			ancestors
		) => {
			if (name === directive) {
				const fieldPath = ancestors
					.filter(({ kind }: NotWorthIt) => kind === 'Field')
					.map(({ name: { value: name } }: NotWorthIt) => name);

				const fragmentDefinition: NotWorthIt = ancestors.find(
					({ kind }: NotWorthIt) => kind === 'FragmentDefinition'
				);

				// If we are inside a fragment, we must save the reference.
				if (fragmentDefinition) {
					fragmentPersistPaths[fragmentDefinition.name.value] =
						fieldPath;
				} else if (fieldPath.length) {
					paths.push(fieldPath);
				}

				return null;
			}
			return undefined;
		},
	});

	// In case there are any FragmentDefinition items, we need to combine paths.
	if (Object.keys(fragmentPersistPaths).length) {
		visit(originalQuery, {
			FragmentSpread: (
				{ name: { value: name } },
				_key,
				_parent,
				_path,
				ancestors
			) => {
				if (fragmentPersistPaths[name]) {
					let fieldPath = ancestors
						.filter(({ kind }: NotWorthIt) => kind === 'Field')
						.map(({ name: { value: name } }: NotWorthIt) => name);

					fieldPath = fieldPath.concat(fragmentPersistPaths[name]);

					const fragment = name;
					let parent = fragmentPaths[fragment][0];

					while (
						parent &&
						parent !== '$ROOT' &&
						fragmentPaths[parent]
					) {
						fieldPath = fragmentPaths[parent]
							.slice(1)
							.concat(fieldPath);
						parent = fragmentPaths[parent][0];
					}

					paths.push(fieldPath);
				}
			},
		});
	}

	return { query, paths };
};

export { extractPersistDirectivePaths };
